var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Location",
    d: "M13.5,12.566a2.4,2.4,0,1,0-2.375-2.4A2.389,2.389,0,0,0,13.5,12.566Zm-.843,8.3a1.178,1.178,0,0,0,1.686,0L19.2,15.941a8.221,8.221,0,0,0,0-11.534,8,8,0,0,0-11.4,0,8.221,8.221,0,0,0,0,11.534ZM7.836,9.611a5.788,5.788,0,0,1,2.529-4.264,5.658,5.658,0,0,1,6.27,0,5.83,5.83,0,0,1,.891,8.9L13.5,18.319,9.474,14.247A5.767,5.767,0,0,1,7.836,9.611Zm13.977,14H5.188a1.2,1.2,0,0,0,0,2.4H21.813a1.2,1.2,0,0,0,0-2.4Z",
    transform: "translate(-4 -2.018)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0fe07479c55b29793766108cdf16f804.svg";
export { ForwardRef as ReactComponent };